import { Accordion as AccordionPrimitive } from "@base-ui/react/accordion";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { cn } from "@/lib/utils";

function Accordion({ className, ...props }) {
  return <AccordionPrimitive.Root data-slot="accordion" className={cn("flex w-full flex-col", className)} {...props} />;
}

function AccordionItem({ className, ...props }) {
  return (
    <AccordionPrimitive.Item data-slot="accordion-item" className={cn("rounded-lg border border-border-primary bg-card mb-3 overflow-hidden", className)} {...props} />
  );
}

function AccordionTrigger({ className, children, ...props }) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          "group/accordion-trigger flex w-full flex-1 items-center justify-between px-4 py-3.5 text-left text-sm font-medium text-text-primary transition-all outline-none bg-background-tertiary/30",
          className,
        )}
        {...props}
      >
        {children}
        <ChevronDownIcon className="pointer-events-none shrink-0 size-4 text-muted-foreground group-aria-expanded/accordion-trigger:hidden" />
        <ChevronUpIcon className="pointer-events-none hidden shrink-0 size-4 text-muted-foreground group-aria-expanded/accordion-trigger:inline" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({ className, children, ...props }) {
  return (
    // `animate-accordion-down`/`-up` were never defined as keyframes anywhere
    // in the app, so this panel used to snap open/closed with no transition
    // at all. Base UI exposes the measured height as `--accordion-panel-height`
    // and flags the enter/exit frame with `data-starting-style`/`data-ending-style`
    // — animating between that and 0 is the documented way to transition it.
    <AccordionPrimitive.Panel
      data-slot="accordion-content"
      className="h-(--accordion-panel-height) overflow-hidden text-sm transition-[height] duration-200 ease-out data-ending-style:h-0 data-starting-style:h-0"
      {...props}
    >
      <div className={cn("px-4 py-3", className)}>{children}</div>
    </AccordionPrimitive.Panel>
  );
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
